import { Badge } from "./ui/badge";

const fmt = (v) => (v == null || v === "" ? "—" : String(v));
const PRIORITY = ["tab9", "tabPretrialOrder", "tab4"]; // Δημοσιεύσεις, Διατάξεις Προδικασίας, Στοιχεία Δικασίμου πρώτα

/** Οι 9 καρτέλες της «Πορείας Υπόθεσης» SOLON ως αναπτυσσόμενοι πίνακες (κοινό: dialog ελέγχου + κάρτα υπόθεσης). */
export const SolonTabsView = ({ tabs, testPrefix = "solon-tab" }) => {
  if (!tabs) return null;
  const order = [...PRIORITY.filter((k) => tabs[k]), ...Object.keys(tabs).filter((k) => !PRIORITY.includes(k))];
  return (
    <div className="space-y-2" data-testid={`${testPrefix}s`}>
      {order.map((tid) => {
        const tb = tabs[tid];
        const n = tb.rows?.length || 0;
        const hi = PRIORITY.includes(tid);
        return (
          <details key={tid} className={`rounded border bg-white ${hi ? "border-slate-400" : ""}`} open={n > 0 && hi} data-testid={`${testPrefix}-${tid}`}>
            <summary className="cursor-pointer px-3 py-1.5 text-xs font-semibold text-slate-700 flex items-center justify-between">
              <span>{tb.label}</span><Badge variant={n ? "default" : "secondary"} className={n ? "bg-slate-800" : ""}>{n}</Badge>
            </summary>
            <div className="px-3 pb-3 overflow-x-auto">
              {n ? (
                <table className="w-full text-xs border rounded">
                  <thead className="bg-slate-50"><tr>{tb.headers.map((h) => <th key={h} className="text-left px-2 py-1 font-medium text-slate-600 whitespace-nowrap">{h}</th>)}</tr></thead>
                  <tbody>{tb.rows.map((r, i) => <tr key={i} className="border-t align-top">{tb.headers.map((h) => <td key={h} className="px-2 py-1">{fmt(r[h])}</td>)}</tr>)}</tbody>
                </table>
              ) : <p className="text-xs text-slate-400 py-1">Δεν υπάρχουν δεδομένα</p>}
            </div>
          </details>
        );
      })}
    </div>
  );
};
